import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WelcomePopComponent } from '@features/dashboard/components/dashboard/welcome-pop/welcome-pop.component';
import { UserRoles } from '@shared/constants/user-roles.constants';
import { UserService } from '../oauth-service/user.service';

@Injectable({
  providedIn: 'root',
})
export class WelcomeService {
  readonly userService = inject(UserService);
  readonly matDialog = inject(MatDialog);

  isWelcomeDialogOpen = false;

  openWelcomePopUpModal() {
    const isLoggedIn = this.userService.loggedinB2C;

    this.userService
      .checkIfUserHasRole(UserRoles.SMARTPORTAL_DTAG_USER)
      .subscribe({
        next: res => {
          if (isLoggedIn) {
            const welcomePop = localStorage.getItem('welcomePop') === 'true';
            if (!welcomePop && res && this.isWelcomeDialogOpen === false) {
              this.matDialog.open(WelcomePopComponent, {
                minWidth: '20vw',
                minHeight: '20vh',
              });
              this.isWelcomeDialogOpen = true;
            }
          }
        },
      });
  }
}
